<script>
export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        listValue: {
            get() {
                return this.value.join('\n');
            },
            set(list) {
                this.$emit('input', list.split('\n'));
            },
        },
    },
};
</script>

<template>
    <b-form-textarea
        v-model="listValue"
        rows="10"
    />
</template>

<style
    scoped
    lang="scss"
>

</style>
